import React from 'react';
import { PhoneIcon, FileTextIcon, ActivityIcon } from 'lucide-react';
export function ActivityHealth() {
  return <div className="bg-slate-800 border border-slate-700 rounded-lg p-6 mb-6" data-id="element-1">
      <h3 className="text-lg font-semibold text-white mb-4 flex items-center gap-2" data-id="element-2">
        <ActivityIcon className="w-5 h-5 text-blue-400" data-id="element-3" />
        Activity Health
      </h3>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-4">
        <div className="bg-slate-900/50 p-4 rounded-lg border border-slate-700/50 flex flex-col items-center text-center" data-id="element-5">
          <div className="mb-2 p-2 bg-blue-500/10 rounded-full" data-id="element-6">
            <PhoneIcon className="w-4 h-4 text-blue-400" data-id="element-7" />
          </div>
          <span className="text-2xl font-bold text-white" data-id="element-8">42</span>
          <span className="text-xs text-slate-400" data-id="element-9">Avg Calls / LO / Day</span>
        </div>

        <div className="bg-slate-900/50 p-4 rounded-lg border border-slate-700/50 flex flex-col items-center text-center" data-id="element-10">
          <div className="mb-2 p-2 bg-purple-500/10 rounded-full" data-id="element-11">
            <FileTextIcon className="w-4 h-4 text-purple-400" data-id="element-12" />
          </div>
          <span className="text-2xl font-bold text-white" data-id="element-13">3.5</span>
          <span className="text-xs text-slate-400" data-id="element-14">Avg Pulls / LO / Day</span>
        </div>

        <div className="bg-slate-900/50 p-4 rounded-lg border border-slate-700/50 flex flex-col items-center text-center" data-id="element-15">
          <div className="mb-2 p-2 bg-emerald-500/10 rounded-full" data-id="element-16">
            <ActivityIcon className="w-4 h-4 text-emerald-400" data-id="element-17" />
          </div>
          <span className="text-2xl font-bold text-white" data-id="element-18">12%</span>
          <span className="text-xs text-slate-400" data-id="element-19">Activity-to-Fund</span>
        </div>
      </div>
    </div>;
}